import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IbBookingSwitchSellComponent } from './ib-booking-switch-sell.component';

import { TranslateModule } from '@ngx-translate/core';
import { IbSwitchSellCarCardComponent } from './components/ib-switch-sell-car-card/ib-switch-sell-car-card.component';
import { IbSwitchSellCarCardNoDispoComponent } from './components/ib-switch-sell-car-card-no-dispo/ib-switch-sell-car-card-no-dispo.component';
import { IbSwitchSellHotelCardComponent } from './components/ib-switch-sell-hotel-card/ib-switch-sell-hotel-card.component';
import { IbSwitchSellHotelCardNoDispoComponent } from './components/ib-switch-sell-hotel-card-no-dispo/ib-switch-sell-hotel-card-no-dispo.component';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
    declarations: [
        IbBookingSwitchSellComponent,
        IbSwitchSellCarCardComponent,
        IbSwitchSellCarCardNoDispoComponent,
        IbSwitchSellHotelCardComponent,
        IbSwitchSellHotelCardNoDispoComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        SharedModule
    ],
    exports: [
        IbBookingSwitchSellComponent
    ]
})
export class IbBookingSwitchSellModule { }